import { render, staticRenderFns } from "./EditorPageSelector.vue?vue&type=template&id=ba995e88&scoped=true&"
import script from "./EditorPageSelector.vue?vue&type=script&lang=js&"
export * from "./EditorPageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba995e88",
  null
  
)

export default component.exports